<template>
    <div class="object-block-company" :class="objectBlockClasses">
        <div class="object-block__header">
            <div class="object-block__header-title-container">
                <CompassObject :object="objectType" :size="objectSize" />
                <div>
                    <div class="object-block__header-name-container">
                        <BlockName :name="name" :link="!displayLink ? linkCard : null" />
                        <CompassTooltip
                            :disabled="!typeLabel"
                            :content="typeLabel"
                            :arrow="false"
                            placement="top"
                        >
                            <DotThird :type="data.type" />
                        </CompassTooltip>
                    </div>
                    <div
                        v-if="
                            [
                                OBJECT_BLOCK_VARIANT.SIMPLE_PREVIEW,
                                OBJECT_BLOCK_VARIANT.SELECTION,
                            ].includes(variant)
                        "
                        class="typographies-paragraph-caps-small-regular object-block__header-caption"
                    >
                        {{ objectCaption }}
                    </div>
                </div>
            </div>
            <CompassLink v-if="displayLink" :label="linkLabel" :link="linkCard" target="_blank" />
            <div v-if="displayActions" class="object-block__header-actions">
                <CompassButton
                    type="tertiary"
                    :label="$t.__('common.actions.edit')"
                    @click="$emit('edit')"
                />
                <CompassButton
                    type="tertiary"
                    :label="$t.__('common.actions.unlink_object')"
                    @click="$emit('unlink')"
                />
            </div>
            <CompassIconButton
                v-if="variant === OBJECT_BLOCK_VARIANT.LINKED"
                icon="close"
                @click="$emit('unlink')"
            />
        </div>
        <BlockDescriptionListPart
            v-if="displayDescriptionList && hasDescriptionListItem"
            v-bind="$props"
        />
        <slot name="contact" />
    </div>
</template>

<script>
import BlockGeneric from 'vcomponents/common/object/BlockGeneric.vue';
import BlockDescriptionListPart from 'vcomponents/common/object/BlockDescriptionListPart.vue';
import { getFullNameUser } from 'Helpers/avatarHelper.js';
import ThirdTypeTags from 'Dictionaries/thirdTypeTags.js';
import DotThird from 'vcomponents/common/TagThird/DotThird.vue';

export default {
    components: { BlockDescriptionListPart, DotThird },
    extends: BlockGeneric,
    props: {
        isEmbedded: {
            type: Boolean,
            default: false,
        },
        showEmail: {
            type: Boolean,
            default: true,
        },
        showPhone: {
            type: Boolean,
            default: true,
        },
        showMobile: {
            type: Boolean,
            default: true,
        },
        showAddress: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            dotColor: '',
            objectType: 'company',
        };
    },
    computed: {
        hasDescriptionListItem() {
            return (
                (this.showEmail && !!this.data.email) ||
                (this.showPhone && !!this.data.phone_number) ||
                (this.showMobile && !!this.data.mobile_number) ||
                (this.showAddress && !!this.data.address)
            );
        },
        name() {
            return this.data.name ?? `${this.data.first_name} ${this.data.last_name}`;
        },
        objectBlockClasses() {
            return [
                this.isEmbedded ? 'object-block--embedded' : '',
                'object-block',
                `object-block--${this.variant}`,
            ];
        },
        typeLabel() {
            return ThirdTypeTags[this.data.type]?.label ?? '';
        },
        objectSize() {
            return this.isEmbedded ? 'extra-small' : 'small';
        },
    },
    created() {
        this.linkCard = this.getLink({
            id: this.data.object ? this.data.object.id : this.data.id,
            type: 'company',
            subtype: this.data.object ? this.data.object.sub_type : this.data.type,
        });
        this.objectCaption = this.data.address
            ? `${this.data.address.postal_code} ${this.data.address.city}`
            : '';

        if (this.data.contact) {
            this.data.contact.link = this.getLink({
                id: this.data.contact.id,
                type: 'people',
                subtype: 'people',
            });
            this.data.contact.fullName = getFullNameUser(this.data.contact, true);
        }
    },
};
</script>
<style lang="scss" scoped>
.object-block-company {
    .object-block-contact {
        margin-top: var(--spacing-3);
    }
}
</style>
